import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconData(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M14.668 2.36C13.79 2.118 13 2.84 13 3.748c0 .765.57 1.396 1.293 1.646A6.989 6.989 0 0 1 19 12c0 .443-.044.874-.124 1.291-.141.738.117 1.528.765 1.909.79.464 1.82.14 2.048-.747A9.829 9.829 0 0 0 22 12c0-4.594-3.107-8.472-7.332-9.64ZM12 19c-3.87 0-7-3.13-7-7a6.989 6.989 0 0 1 4.707-6.606C10.43 5.144 11 4.513 11 3.748c0-.91-.791-1.63-1.668-1.389A9.994 9.994 0 0 0 2 12c0 5.52 4.47 10 9.99 10a9.95 9.95 0 0 0 6.95-2.816c.65-.63.432-1.673-.348-2.132-.655-.386-1.484-.215-2.062.279A6.936 6.936 0 0 1 12 19Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
